import { memo } from "react";
import styled from "styled-components";

const StyledForm = styled.form`
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;

  box-sizing: border-box;
  min-width: 0;
`;

const Form = memo(({ children, ...rest }) => (
  <StyledForm {...rest}>{children}</StyledForm>
));

export default Form;
